<template>
    <div class="page">
        <img src="https://cosimg.cdbost.cn/cdboost/sy/gywm01.jpg" alt="" style="width: 100%;height:27.5625rem">
        <div class="box1">
                <div class="box2">
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp成都博高电管家科技有限公司&nbsp(下称“博高电管家“)&nbsp是成都博高信息技术股份有限公司下属专业从事电动自行车无人值守业务，充换电业务和新能源汽车有序充电业务的子公司，致力于成为国内一流的创新型安全用电管理专家方案提供商。<br>
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp博高电管家传承博高信息20多年用电安全的产品设计，系统开发经验，专业打造安全有序充电，无人值守的整体解决方案。该方案采用国际标准物联网通信技术、云计算、大数据以及Ai人工智能算法，能够有效解决停车被盗、充电消防安全等社会痛点。
                </div>
                <div class="box3">
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp母公司博高信息是一家专业从事智能电网行业用电信息采集领域的软件开发，设备制造和产品销售的高新技术企业，是新三板挂牌企业<br>
            股票名称:博高信息股票代码:833884.<br>
                &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp博高信息是国际和国内LoRaWAN联盟成员，拥有国内最早从事LoRa技术研发的团队，是国内第一家利用LoRaWAN技术实现规模化应用的厂商，是国内领先的物联网整体解决方案提供商。
                </div>
                <div class="box4">
                    <img src="../assets/sy/about01.png" alt="" class="pic1"><span style="color: #0065ad;font-size: 3.125rem;font-weight: bold;">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp企业简介</span>
                </div>
        </div>
        <div class="ex">
            <span style="display: flex;justify-content: center;font-size: 3rem;font-weight: bold"><br>企业历程</span>
        </div>
        <div class="cult">
            <div style="display: flex;justify-content: center;font-size: 3rem;font-weight: bold;padding-top: 3rem">&nbsp&nbsp企业文化</div>
        </div>
        <div class="qual">
            <span style="display: flex;justify-content: center;font-size: 3rem;font-weight: bold;padding-top: 1.5rem">&nbsp&nbsp&nbsp企业资质</span>
        </div>
        <div class="lab">
            <div class="lab1">
                <img src="../assets/sy/lab1.png" alt="" style="width: 26.875rem;height: 39.9375rem">
                <div style="flex-direction: column;font-size: 2.25rem">
                    <br>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp高温实验室
                </div>
            </div>
            <div class="lab2">
                <div class="lab3">
                    <div>
                        <img src="../assets/sy/lab2.png" alt="" style="width: 34.375rem;height: 18.75rem">
                    </div>
                    <div>
                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp芯片烧写
                    </div>
                </div>
                <div class="lab3">
                    <div>
                        <img src="../assets/sy/lab3.png" alt="" style="width: 34.375rem;height: 18.75rem">
                    </div>
                    <div>
                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp计量校验实验室
                    </div>
                </div>
                <div class="lab3">
                    <div>
                        <img src="../assets/sy/lab4.png" alt="" style="width: 34.375rem;height: 18.75rem">
                    </div>
                    <div>
                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp电磁兼容实验室
                    </div>
                </div>
                <div class="lab3">
                    <div>
                        <img src="../assets/sy/lab5.png" alt="" style="width: 34.375rem;height: 18.75rem">
                    </div>
                    <div>
                        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp环境实验室
                    </div>
                </div>
            </div>
            <div style="flex: 1">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "service"
    }
</script>

<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
    }
</style>
<style scoped  lang="scss">
    .box1 {
        position: relative;
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: repeat(5, 1fr);
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        background: #DFE8EF;
        height: 62.5rem;
        width: 100%;
    }

    .box2 {
        grid-area: 1 / 1 / 2 / 2;
        color: #333333;
        position: relative;
        background: #DFE8EF;
        font-size: 1.875rem;
        margin-top: 1.875rem;
        line-height: 3.75rem;
        margin-left: 1.5625rem;
        margin-right: 1.5625rem;
        width: 95%;
        height: 22.5rem;
    }
    .box3 {
        grid-area: 2 / 1 / 3 / 2;
        color: #666666;
        position: relative;
        background: #DFE8EF;
        font-size: 1.875rem;
        line-height: 3.75rem;
        margin-top: 8.25rem;
        margin-left: 1.5625rem;
        margin-right: 1.5625rem;
        width: 73.125rem;
        height: 22.5rem;
    }
    .box4 {
        grid-area: 1 / 2 / 3 / 3;
        margin-top: 3.125rem;
        position: relative;
    }
    .pic1 {
        width:34.375rem;
        height:31.875rem;
    }
    .lab {
        display: flex;
        position: relative;
        width: 120rem;
        height: 62.5rem;
        background-image: url("../assets/sy/about06.jpg");
        background-size: 120rem 62.5rem;
    }
    .lab1 {
        color: #666666;
        flex:5;
        display: flex;
        margin-left: 6.25rem;
        margin-top: 11.25rem;
        flex-direction: column;
    }
    .lab2 {
        color: #666666;
        flex:12;
        display: flex;
        margin-top: 11.25rem;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .lab3 {
        display: flex;
        flex-direction: column;
        font-size: 2.25rem;
    }
    .ex {
        color: #3b70b2;
        position: relative;
        width: 100%;
        height: 62.5rem;
        background-image: url("../assets/sy/gywm03.jpg");
        background-size: 120rem 62.5rem;
    }
    .cult {
        color: #3b70b2;
        position: relative;
        width: 100%;
        height: 62.5rem;
        background-image: url("../assets/sy/gywm04.jpg");
        background-size: 120rem 62.5rem;
    }
    .qual {
        color: #d8b575;
        position: relative;
        width: 100%;
        height: 62.5rem;
        background-image: url("../assets/sy/gywm05.jpg");
        background-size: 120rem 62.5rem;
    }
</style>


